import { first } from "lodash";
import { getDayOfWeek } from "@/utils/time";

export const dayOfWeekFilter = items => {
  return getDayOfWeek(first(items).startDate);
};
